import Ajax from '@/libs/Ajax'

// 后台命名空间
const NAME_SPACE = "/aseapi/console/Environment";

export default {
  // 查询所有基础信息
  doQuery(){
    return Ajax.get(`${NAME_SPACE}/query`);
  },
  doQueryStatus(){
    return Ajax.get(`${NAME_SPACE}/queryStatus`);
  },
  queryBasicsStatus(){
    return Ajax.get(`${NAME_SPACE}/queryBasicsStatus`);
  }
};
